import React from "react";
import { useParams } from "react-router-dom";
import { Logo } from "../components/logo";
import axios from "axios";

function ValidateAccount() {
  // 'loading' | 'success' | 'error'  → estado de la activación inicial
  const [status, setStatus] = React.useState("loading");
  const [message, setMessage] = React.useState("");

  // Reenvío de activación (se muestra solo cuando la activación falla)
  const [email, setEmail] = React.useState("");
  // 'idle' | 'sending' | 'sent' | 'error'
  const [resendStatus, setResendStatus] = React.useState("idle");
  const [resendMessage, setResendMessage] = React.useState("");

  let { uid } = useParams();
  let { token } = useParams();

  const baseURL = process.env.REACT_APP_API_BASE_URL || "";

  // The activation token is single-use: React.StrictMode double-invokes effects
  // in dev, so without this guard the SECOND call hits an already-activated
  // account ("stale token") and flips a successful activation into an error.
  const startedRef = React.useRef(false);

  React.useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    async function fetchData() {
      try {
        await axios.post(
          `${baseURL}/api/v1/auth/users/activation/`,
          { uid, token },
          { timeout: 20000 } // never spin forever if the network stalls
        );
        setStatus("success");
        setMessage("¡Felicidades! Tu cuenta fue activada correctamente.");
      } catch (error) {
        setStatus("error");
        const detail = error?.response?.data?.detail;
        const timedOut = error?.code === "ECONNABORTED";
        setMessage(
          detail ||
            (timedOut
              ? "El servidor no respondió a tiempo. Revisa tu conexión e inténtalo de nuevo."
              : "El enlace de activación no es válido o ya expiró.")
        );
      }
    }
    fetchData();
    // startedRef guards against StrictMode's double-invoke and any re-run from
    // these deps changing — the activation call itself still only fires once.
  }, [baseURL, token, uid]);

  async function handleResend(e) {
    e.preventDefault();
    setResendStatus("sending");
    setResendMessage("");
    try {
      await axios.post(`${baseURL}/api/v1/auth/users/resend_activation/`, {
        email,
      });
      setResendStatus("sent");
      setResendMessage(
        "Si el correo corresponde a una cuenta sin activar, te enviamos un nuevo enlace. Revisa tu bandeja de entrada."
      );
    } catch (error) {
      setResendStatus("error");
      const data = error?.response?.data;
      const detail =
        data?.detail ||
        data?.email?.[0] ||
        "No pudimos reenviar el enlace. Verifica el correo e inténtalo de nuevo.";
      setResendMessage(detail);
    }
  }

  return (
    <div className="container-scroller">
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="content-wrapper d-flex align-items-center auth px-0">
          <div className="row w-100 mx-0">
            <div className="col-lg-4 mx-auto">
              <div className="auth-form-light text-left py-5 px-4 px-sm-5">
                <div className="brand-logo">
                  <Logo />
                </div>

                {status === "loading" && (
                  <div className="card">
                    <div className="card-body">
                      <div className="loader-demo-box">
                        <div className="bar-loader">
                          <span></span>
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      </div>
                      <p className="text-muted mt-3 mb-0">
                        Activando tu cuenta…
                      </p>
                    </div>
                  </div>
                )}

                {status === "success" && (
                  <div className="card">
                    <div className="card-body">
                      <h4 className="mb-2">¡Cuenta activada!</h4>
                      <p className="text-muted mb-0">{message}</p>
                      <p className="text-muted mt-2 mb-0">
                        Ya puedes iniciar sesión desde el enlace de acceso de tu
                        academia.
                      </p>
                    </div>
                  </div>
                )}

                {status === "error" && (
                  <div className="card">
                    <div className="card-body">
                      <h4 className="mb-2">Enlace no válido</h4>
                      <p className="text-muted">{message}</p>

                      {resendStatus === "sent" ? (
                        <div className="alert alert-success mb-0">
                          {resendMessage}
                        </div>
                      ) : (
                        <form onSubmit={handleResend} className="pt-2">
                          <p className="mb-2">
                            Ingresa tu correo y te enviaremos un nuevo enlace de
                            activación:
                          </p>
                          <div className="form-group">
                            <input
                              type="email"
                              className="form-control form-control-lg"
                              placeholder="tu@correo.com"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              required
                            />
                          </div>
                          {resendStatus === "error" && (
                            <div className="alert alert-danger py-2">
                              {resendMessage}
                            </div>
                          )}
                          <button
                            type="submit"
                            className="btn btn-block btn-primary btn-lg font-weight-medium"
                            disabled={resendStatus === "sending"}
                          >
                            {resendStatus === "sending"
                              ? "Enviando…"
                              : "Reenviar enlace de activación"}
                          </button>
                        </form>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { ValidateAccount };
